export default {
  pages: state => state.pages,
  selectedPage: state => state.activePage,
  history: state => state.history,
  loadingHistory: state => state.loadingHistory,
};
